module.exports = __webpack_public_path__ + "img/phase0.b456e0f1.png";